import { Props } from './Loader'

export type LoaderProps = Props

export { default } from './Loader'
